
    <spaq-layout-account-container>
      <spaq-layout-account-header>
        </spaq-layout-account-header>
      <div class="d-flex flex-row p-0 m-0 align-items-stretch">
        <div class="col-md-2 p-0 h-100 bg-white">
          <!-- <spaq-layout-account-sidebar></spaq-layout-account-sidebar> -->
        </div>
        <div class="">
          <ng-content></ng-content>
        </div>
      </div>

    </spaq-layout-account-container>
  


// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/layout/containers/layout-account.component.ts.LayoutAccountComponent.html